<app-datepicker-filter
	(change)="onChange($event, dateRangeType.FROM)"
	[dateRangeType]="dateRangeType.FROM"
	[defaultFilterData]="defaultFilterData"
	[id]="defaultFilterData.prefix + 'fromDatepicker'"
	[placeholder]="defaultFilterData.i18nPath + '.filters.from.placeholder'"
	[readOnly]="true"
	[shouldReset]="resetFromDate.asObservable()"
></app-datepicker-filter>
<br/>
<app-datepicker-filter
	(change)="onChange($event, dateRangeType.TO)"
	[dateRangeType]="dateRangeType.TO"
	[defaultFilterData]="defaultFilterData"
	[id]="defaultFilterData.prefix + 'toDatepicker'"
	[minDate]="toDateMinimum"
	[placeholder]="defaultFilterData.i18nPath + '.filters.to.placeholder'"
	[readOnly]="true"
	[shouldReset]="resetToDate.asObservable()"
></app-datepicker-filter>
